import React from "react";

export default function ContactImg(props) {
  const theme = props.theme;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      width="738.21997"
      height="542.26204"
      viewBox="0 0 738.21997 542.26204"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Contact Me</title>
      <path
        d="M376.80675,461.2862,367.08116,358.191l-29,1,22.95655,101.80713a12.007,12.007,0,1,0,15.769.28808Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#ffb8b8"
      />
      <path
        id="fe9c178f-ba3b-4efa-8f02-91d714d1abd5-1489"
        data-name="Path 2352"
        d="M928.128,691.07a106.36058,106.36058,0,0,1-4.968,29.4c-.069.221-.142.439-.214.659H904.403c.02-.2.04-.419.059-.659,1.236-14.213,8.364-100.716-.158-115.509C905.05,606.162,929.562,645.909,928.128,691.07Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#f0f0f0"
      />
      <path
        id="f50bd4c5-ec05-4fbf-a485-473f9149da92-1490"
        data-name="Path 2353"
        d="M925.152,719.752c-.324.462-.662.924-1.007,1.379H895.057c.221-.393.476-.855.772-1.379,4.806-8.674,19.029-34.6,32.233-61.487,14.189-28.889,27.206-58.873,26.11-69.726C954.509,590.987,964.324,665.601,925.152,719.752Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#f0f0f0"
      />
      <path
        id="b6259e39-7a62-4774-8afe-aeda515ec4c0-1491"
        data-name="Path 2354"
        d="M286.243,675.924a158.39368,158.39368,0,0,0,7.4,43.785c.1.329.211.653.319.982h27.612c-.029-.295-.059-.624-.088-.982-1.841-21.166-12.456-149.988.236-172.018C320.611,549.478,284.098,608.67,286.243,675.924Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#f0f0f0"
      />
      <path
        id="f2d2e7cd-3eee-4477-b585-9c3536763a3f-1492"
        data-name="Path 2355"
        d="M288.315,719.709c.231.329.471.658.717.982h20.714c-.157-.28-.339-.609-.55-.982-3.422-6.176-13.551-24.642-22.953-43.785-10.1-20.572-19.374-41.924-18.593-49.652C267.409,628.014,260.417,681.148,288.315,719.709Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#f0f0f0"
      />
      <path
        id="b281e673-bc66-4b3c-8141-26a0e4a40fd7-1493"
        data-name="Path 2359"
        d="M886.477,613.053H598.21a5.345,5.345,0,0,1-5.338-5.338V536.207a5.345,5.345,0,0,1,5.338-5.338H886.477a5.345,5.345,0,0,1,5.338,5.338v71.507A5.345,5.345,0,0,1,886.477,613.053ZM598.21,533a3.207,3.207,0,0,0-3.2,3.2v71.507a3.207,3.207,0,0,0,3.2,3.2H886.477a3.206,3.206,0,0,0,3.2-3.2V536.207a3.206,3.206,0,0,0-3.2-3.2Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <circle
        id="b3fc6bd5-ca87-44d7-abba-b33fcf0fce6e"
        data-name="Ellipse 472"
        cx="340.10999"
        cy="498.745"
        r="21.745"
        fill="#e6e6e6"
      />
      <path
        id="a4c0ef2a-4063-4b4c-b7a5-712e67abf83e-1494"
        data-name="Path 2357"
        d="M621.222,663.86795a3.624,3.624,0,0,0,0,7.248H792.078a3.624,3.624,0,1,0,.01434-7.248H621.222Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#e6e6e6"
      />
      <path
        id="b6aac15c-fc94-4bcf-bd22-2b2a2d48a317-1495"
        data-name="Path 2358"
        d="M621.222,685.614a3.624,3.624,0,0,0-.01434,7.248H694.742a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#e6e6e6"
      />
      <circle
        id="b30606c0-bedc-4458-8bc1-74f9b5197cfe"
        data-name="Ellipse 473"
        cx="412.10999"
        cy="392.745"
        r="21.745"
        fill="#e6e6e6"
      />
      <path
        id="b0251ef9-ec49-4884-8989-e65898cec086-1496"
        data-name="Path 2360"
        d="M693.222,557.86795a3.624,3.624,0,0,0,0,7.248H864.078a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#e6e6e6"
      />
      <path
        id="f3fbb845-d219-495e-9ae9-9928c3e8cc79-1497"
        data-name="Path 2361"
        d="M693.222,579.614a3.624,3.624,0,0,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#e6e6e6"
      />
      <path
        id="e4b1ee1b-a1a6-4c2a-970c-d47d8b3fd870-1498"
        data-name="Path 2362"
        d="M830.477,436.053H542.21a5.345,5.345,0,0,1-5.338-5.338V184.207a5.345,5.345,0,0,1,5.338-5.338H830.477a5.345,5.345,0,0,1,5.338,5.338V430.714a5.344,5.344,0,0,1-5.338,5.338ZM542.21,181a3.207,3.207,0,0,0-3.2,3.2V430.714a3.207,3.207,0,0,0,3.2,3.2H830.477a3.206,3.206,0,0,0,3.2-3.2V184.207a3.207,3.207,0,0,0-3.2-3.2Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <circle
        id="b10e3043-e731-4e82-8fca-75f9298f00b8"
        data-name="Ellipse 474"
        cx="356.10999"
        cy="43.34799"
        r="21.745"
        fill={theme.imageHighlight}
      />
      <path
        id="b8c117d2-374b-429b-9a52-be2e8d6b8684-1499"
        data-name="Path 2363"
        d="M637.222,207.72a3.624,3.624,0,0,0,0,7.248H808.078a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#ccc"
      />
      <path
        id="b1daea5a-aca4-46bb-ab1c-9e5888030a38-1500"
        data-name="Path 2364"
        d="M637.222,229.466a3.624,3.624,0,0,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#ccc"
      />
      <path
        id="a9f6ff6a-7451-4bea-bc5a-628f4bebd58b-1501"
        data-name="Path 2366"
        d="M464.08,700.191h-22l-13-183-.5,46.5-48,128-19-15,31.5-127.5-15-71h98Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.secondaryText}
      />
      <circle
        id="a663db6f-60a1-421c-a7e7-5d04aff0cacb"
        data-name="Ellipse 475"
        cx="198.19"
        cy="47.322"
        r="26"
        fill="#ffb8b8"
      />
      <path
        id="f3cb7545-9624-45d8-a11d-440f1a34aab0-1502"
        data-name="Path 2370"
        d="M479.081,492.191c-42.478-10.9-82.334-18.245-107-5,4.32-45.411-.677-103.379-15.5-163.965-4.814-19.679-1.549-37.411,16-47.535l23.5-13.5,36,1,18.783,10.392a47.16,47.16,0,0,1,25.254,50.977C466.025,377.667,471.479,434.985,479.081,492.191Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <path
        id="f6231dd0-d8a8-465e-b214-b8e5de78c90d-1503"
        data-name="Path 2372"
        d="M382.081,365.191l-47-3c3.672-46.236,14.122-71.511,30-80l17,20Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <path
        id="b1bce2c7-12e1-4551-8863-d6d142670d08-1504"
        data-name="Path 2375"
        d="M898.966,404.074H610.698a5.344,5.344,0,0,1-5.338-5.338V272.229a5.344,5.344,0,0,1,5.338-5.338H898.966a5.344,5.344,0,0,1,5.338,5.338V398.736A5.344,5.344,0,0,1,898.966,404.074Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.imageHighlight}
      />
      <path
        id="b8b7ef86-e6be-48b5-b7f8-365881aa5bd2-1505"
        data-name="Path 2376"
        d="M669.404,310.985a3.624,3.624,0,0,0,0,7.248H840.261a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#fff"
      />
      <path
        id="a9b62e3b-06cf-4a55-8c8f-4aeba6e5e4c7-1506"
        data-name="Path 2377"
        d="M669.404,331.985a3.624,3.624,0,0,0,0,7.248H840.261a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#fff"
      />
      <path
        id="a12f9c39-a43a-4056-b48c-3363dc06a37f-1507"
        data-name="Path 2378"
        d="M669.404,352.731a3.624,3.624,0,0,0,0,7.248h73.52a3.624,3.624,0,0,0,0-7.248Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#fff"
      />
      <path
        id="e7c770ea-313c-4db5-898e-f0c92c7afc68-1508"
        data-name="Path 1784"
        d="M437.945,191.978c-2.422-.254-4.706,1.035-7.089,1.562-4.9,1.074-9.92-1.152-14.958-1.133a27.76793,27.76793,0,0,0-12.3,3.671,29.7002,29.7002,0,0,0-8.2,5.741,13.37808,13.37808,0,0,0-3.912,9.023,14.78452,14.78452,0,0,1-.176,5.858,16.486,16.486,0,0,1-1.8,2.734,8.123,8.123,0,0,0-.84,6.776,22.47814,22.47814,0,0,0,4.042,6.054c3.242,4.159,5.273,9.139,8.182,13.553a42.184,42.184,0,0,0,4.257,5.409,3.00843,3.00843,0,0,0,.918.722,2.81683,2.81683,0,0,0,1.074.156c6.171.176,12.557.312,18.239-2.109a8.33805,8.33805,0,0,0,4.374-3.515,12.40016,12.40016,0,0,0,.429-7.03,32.21834,32.21834,0,0,1,.176-7.811,3.437,3.437,0,0,1,1-2.324,3.124,3.124,0,0,1,3.124-.1,8.51586,8.51586,0,0,0,3.105.937c2.129,0,3.476-2.422,3.906-4.531a10.623,10.623,0,0,1,4.355-9.94,15.037,15.037,0,0,0,2.675-13.338C447.123,197.954,442.827,192.466,437.945,191.978Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <path
        id="a71493d8-729a-4860-baf4-314f557d0142-1509"
        data-name="Path 2356"
        d="M814.477,719.053H526.21a5.345,5.345,0,0,1-5.338-5.338V642.207a5.344,5.344,0,0,1,5.338-5.338H814.477a5.345,5.345,0,0,1,5.338,5.338v71.507a5.345,5.345,0,0,1-5.338,5.338ZM526.21,639a3.207,3.207,0,0,0-3.2,3.2v71.507a3.207,3.207,0,0,0,3.2,3.2H814.477a3.206,3.206,0,0,0,3.2-3.2V642.207a3.207,3.207,0,0,0-3.2-3.2Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <path
        d="M487.80675,457.2862,478.08116,354.191l-29,1,22.95655,101.80713a12.007,12.007,0,1,0,15.769.28808Z"
        transform="translate(-230.89001 -178.86898)"
        fill="#ffb8b8"
      />
      <path
        id="e519ab1a-c4cc-4940-8e12-0133c9949239-1510"
        data-name="Path 2374"
        d="M488.08,356.191l-44,10-2-72,25,1Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <path
        d="M441.38386,698.38982l31.91439-.00129h.00129a20.33944,20.33944,0,0,1,20.33835,20.338v.66091l-52.25306.00194Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <path
        d="M361.22777,673.121,388.057,690.40452l.00109.0007a20.33945,20.33945,0,0,1,6.08236,28.11207l-.358.55559-43.92715-28.2982Z"
        transform="translate(-230.89001 -178.86898)"
        fill={theme.compImgColor}
      />
      <rect
        id="f8d1573e-a821-470f-abec-777083782890"
        data-name="Rectangle 256"
        y="540.26202"
        width="738.21997"
        height="2"
        fill="#cacaca"
      />
    </svg>
  );
}
